import i18next from 'i18next'

const { t } = i18next

export const getConstants = () => ({
  t_caps: {
    //SETTINGS
    show_users: t('constants.t_caps.show_users', 'Visualizza utenti'),
    manage_users: t('constants.t_caps.manage_users', 'Gestisci utenti'),
    show_brands: t('constants.t_caps.show_brands', 'Visualizza brand'),
    manage_brands: t('constants.t_caps.manage_brands', 'Gestisci brand'),
    show_categories: t('constants.t_caps.show_categories', 'Visualizza categorie'),
    manage_categories: t('constants.t_caps.manage_categories', 'Gestisci categorie'),
    show_dealers: t('constants.t_caps.show_dealers', 'Visualizza dealer'),
    manage_dealers: t('constants.t_caps.manage_dealers', 'Gestisci dealer'),

    //APPOINTMENTS
    show_appointments: t('constants.t_caps.show_appointments', 'Visualizza visite'),
    manage_appointments: t('constants.t_caps.manage_appointments', 'Gestisci visite'),
    change_status_appointments: t('constants.t_caps.change_status_appointments', 'Modifica stato visite'),
    show_contracts: t('constants.t_caps.show_contracts', 'Visualizza pratiche contrattuali'),
    manage_contracts: t('constants.t_caps.manage_contracts', 'Gestisci pratiche contrattuali'),
    change_status_contracts: t('constants.t_caps.change_status_contracts', 'Modifica stato pratiche contrattuali'),
    show_metadata: t('constants.t_caps.show_metadata', 'Visualizza metadati'),
    manage_metadata: t('constants.t_caps.manage_metadata', 'Gestisci metadati'),
    show_calendar: t('constants.t_caps.show_calendar', 'Visualizza calendario'),
    manage_calendar: t('constants.t_caps.manage_calendar', 'Gestisci calendario'),

    //HOME
    show_documents: t('constants.t_caps.show_documents', 'Visualizza documenti'),
    manage_documents: t('constants.t_caps.manage_documents', 'Gestisci documenti'),
    show_messages: t('constants.t_caps.show_messages', 'Visualizza messaggi'),
    manage_messages: t('constants.t_caps.manage_messages', 'Gestisci messaggi'),
    show_map: t('constants.t_caps.show_map', 'Visualizza mappa'),
  },

  filter_by_selected: {
    unselected: t('filter_by_selected.unselected', 'Non selezionati'),
    selected: t('filter_by_selected.selected', 'Selezionati'),
    all: t('filter_by_selected.all', 'Tutti'),
  },

  appointment_statuses: {
    concluded: t('appointment_statuses.concluded', 'Conclusa'),
    rejected: t('appointment_statuses.rejected', 'Rifiutata'),
    pending: t('appointment_statuses.pending', 'Inserita'),
  },

  contract_statuses: {
    signed: t('contract_statuses.signed', 'Firmato'),
    rejected: t('contract_statuses.rejected', 'Rifiutata'),
    pending: t('contract_statuses.pending', 'In attesa'),
    expired: t('contract_statuses.expired', 'Scaduto'),
  },

  brand_statuses: {
    active: t('brand_statuses.active', 'Attivo'),
    inactive: t('brand_statuses.inactive', 'Inattivo'),
  },
  user_statuses: {
    active: t('user_statuses.active', 'Attivo'),
    inactive: t('user_statuses.inactive', 'Inattivo'),
  },
  dealer_statuses: {
    active: t('dealer_statuses.active', 'Attivo'),
    inactive: t('dealer_statuses.inactive', 'Inattivo'),
    all: t('dealer_statuses.all', 'Tutti'),
  },
  dealer_data_statuses: {
    completed: t('dealer_data_statuses.completed', 'Completo'),
    incomplete: t('dealer_data_statuses.incomplete', 'Incompleto'),
    all: t('dealer_data_statuses.all', 'Tutti'),
  },
  appointment_types: {
    engagement: t('appointment_types.engagement', 'Ingaggio'),
    training_with_placement: t('appointment_types.training_with_placement', 'Formazione con inserimento'),
    training_without_placement: t('appointment_types.training_without_placement', 'Formazione senza inserimento'),
    push_activity: t('appointment_types.push_activity', 'Attività di push'),
  },

  appointment_types_colors: {
    engagement: '#4caf50', // verde
    training_with_placement: '#1e88e5', // blu
    training_without_placement: '#fb8c00', // arancione
    push_activity: '#8e24aa', // viola
  },
})

export const getConstantsArray = () => {
  let data = getConstants()
  return Object.keys(data).reduce((acc, k) => ({ ...acc, [k]: Object.keys(data[k]) }), {})
}

export const t_caps = getConstantsArray().t_caps.reduce((t_caps, c) => ({ ...t_caps, [c]: false }), {})
